export default __webpack_public_path__ + "static/media/illustration-working.c9b5ef54.svg";